import styled from "styled-components/native";
import { View } from "react-native";
import { css } from "styled-components";
import { useQaLabel } from "../../hooks";
import { Paragraph } from "../typography";
import { Theme } from "../../theming/types";

export const Selections = styled(View)`
  flex-flow: row wrap;
  row-gap: ${({ theme }: { theme: Theme }) => theme.space["space-1"]};
`;

export const IconContainer = styled(View)`
  align-items: center;
  flex-direction: row;
  height: ${({ theme }: { theme: Theme }) => theme.space["space-6"]};
  margin-right: ${({ theme }: { theme: Theme }) => theme.space["space-1"]};
  width: ${({ theme }: { theme: Theme }) => theme.space["space-6"]};
`;

export const SaddleSelectionContainer = styled(View)<{
  isDetailView: boolean;
  hasThirdColumn: boolean;
}>`
  ${({ isDetailView }: { isDetailView: boolean }) =>
    isDetailView ? "flex-direction: column" : "flex-direction: row"};
  flex-wrap: wrap;
  row-gap: 6px;
  width: 100%;
`;

export const RowContainer = styled(View)<{
  isDetailView: boolean;
  showReplacedRunners?: boolean;
}>`
  ${({ isDetailView, theme }: { isDetailView: boolean; theme: Theme }) =>
    isDetailView
      ? `display: grid;
  column-gap: ${theme.space["space-3"]};
  row-gap: ${theme.space["space-4"]};
  grid-template-columns: min-content 1fr min-content;`
      : "display: flex; flex-direction: row;"}

  ${({
    isDetailView,
    showReplacedRunners
  }: {
    isDetailView: boolean;
    showReplacedRunners?: boolean;
  }) =>
    isDetailView &&
    showReplacedRunners &&
    css`
      display: flex;
      flex-direction: row;
      column-gap: 0;
    `}
`;

export const SaddleDetailsParagraph = styled(Paragraph)<{ scratched: boolean }>`
  ${({ scratched }: { scratched: boolean }) =>
    scratched && "text-decoration: line-through;"}
  font-size: 14px;
  color: ${({ theme }: { theme: Theme }) => theme.colorTokens.content.default};
`;

export const WillPaysContainer = styled(View)`
  font-size: 14px;
`;

export const AlternateContainer = styled(View)`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const AlternateDivider = styled(View)<{ isDark: boolean }>`
  height: 12px;
  width: 1px;
  background-color: ${({ theme, isDark }: { theme: Theme; isDark: boolean }) =>
    isDark
      ? theme.colorTokens.content.onLight
      : theme.colorTokens.content.onDark};
  margin-right: 4px;
`;

export const IconContainerAlternate = styled.View.attrs<{ qaLabel: string }>(
  (props: { qaLabel: string }) => ({
    ...useQaLabel(props.qaLabel)
  })
)<{
  qaLabel: string;
}>`
  align-items: center;
  flex-direction: row;
  height: 20px;
  margin-right: 4px;
  width: 20px;
  position: relative;
`;

export const IconWrapper = styled(View)`
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 99;
`;
